import UserSettingsLayout from "../../layout/UserSettingsLayout.jsx";
import FormContainer from "../../components/form/FormContainer.jsx";
import {useTranslation} from "react-i18next";
import FormControl from "../../components/form/FormControl.jsx";
import FormButton from "../../components/form/FormButton.jsx";
import {useContext, useEffect, useState} from "react";
import useDownloadState from "../../api/utilities/useDownloadState.js";
import {UserApi} from "../../api/authority/generated/index.ts";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import toast from "react-hot-toast";
import LoadingComponent from "../../components/LoadingComponent.jsx";
import FormError from "../../components/form/FormError.jsx";
import Button from "../../components/Button.jsx";

const defaultChangePasswordInput = {
    oldPassword: '',
    newPassword: '',
    newPasswordAgain: '',
};

export default function ChangePassword() {

    let {context, getAuthorityConfiguration} = useContext(GlobalContext);

    let {t} = useTranslation();

    /** @var {ChangePasswordInput} changePasswordInput */
    let [changePasswordInput, setChangePasswordInput] = useState(defaultChangePasswordInput);

    let [buttonPressed, setButtonPressed] = useState(false);
    let [changePasswordState, setDownloading, setResult, setError] = useDownloadState();

    useEffect(() => {

        if (!buttonPressed) {
            return;
        }

        setButtonPressed(false);

        setDownloading(true);

        if (changePasswordInput.newPassword !== changePasswordInput.newPasswordAgain) {
            setDownloading(false);
            setError(() => new Error(t('validation.new-passwords-must-match')));
            return;
        }

        new UserApi(getAuthorityConfiguration())
            .changePassword({
                userId: context.currentIdentity?.user.id,
                changePasswordInput: changePasswordInput,
            }).then((r) => {
            toast.success(t('auth.password-changed'));
        }).catch((e) => setError(e))
            .finally(() => setDownloading(false));


    }, [buttonPressed]);

    return (
        <UserSettingsLayout>
            <FormContainer>
                <LoadingComponent loading={changePasswordState.downloading}>
                    <h2 className="text-xl leading-snug text-slate-800 dark:text-slate-100 font-bold">
                        {t('auth.change-password')}
                    </h2>

                    {changePasswordState.error && (
                        <div className={'pt-5'}>
                            <FormError error={changePasswordState.error}/>
                        </div>
                    )}

                    <div className={'pt-5'}/>

                    <FormControl
                        type="password"
                        label={t('user.current-password')}
                        value={changePasswordInput.oldPassword}
                        onChange={(e) => setChangePasswordInput({...changePasswordInput, oldPassword: e.target.value})}
                    />

                    <div className={'pt-5'}/>

                    <FormControl
                        type="password"
                        label={t('auth.new-password')}
                        value={changePasswordInput.newPassword}
                        onChange={(e) => setChangePasswordInput({...changePasswordInput, newPassword: e.target.value})}
                    />

                    <FormControl
                        type="password"
                        label={t('auth.password-again')}
                        value={changePasswordInput.newPasswordAgain}
                        onChange={(e) => setChangePasswordInput({
                            ...changePasswordInput,
                            newPasswordAgain: e.target.value
                        })}
                    />

                    <div className="flex mt-2">
                        <Button className={'ml-auto'} onClick={() => setButtonPressed(true)}>
                            {t('auth.change-password')}
                        </Button>
                    </div>
                </LoadingComponent>
            </FormContainer>
        </UserSettingsLayout>
    )
        ;
}
